module.exports = __webpack_public_path__ + "img/file.b9d3b3b4.svg";